import { dataItalic } from 'dls-icons-data'
import { createIcon } from '../common'

const IconItalic = /*#__PURE__*/createIcon(dataItalic)
export default IconItalic
